import {
  Component,
  effect,
  HostBinding,
  input,
  booleanAttribute,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'app-backdrop',
  template: ` <ng-content /> `,
  styleUrls: ['./backdrop.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class BackdropComponent {
  visible = input(false, { transform: booleanAttribute });

  @HostBinding('class.visible') show = false;

  constructor() {
    effect(() => (this.show = this.visible()));
  }
}
